import React from "react";
import { store } from "@store";
import { Location } from "../Location";
import { IframeContent } from "./shared/IframeContent";
import { environment } from "../../../environments/environment";

interface Params {
  bookingId: string;
}

export class SickFormLocation extends Location<Params> {
  constructor(bookingId: string) {
    super({ bookingId });

    console.log("CREATING SICK FORM LOCATION", bookingId);

    (window as any).onmessage = (event) => {
      this.navigation.lockNavigation("sickFormSlider", event.data === "isModified:True");

      if (event.data === "shouldClose") {
        this.navigation.close();
        store().snackbars.success("Betalningsformulär har sparats.");
      }
    };
  }

  render() {
    const { bookingId } = this.params;

    return (
      <IframeContent
        url={`${environment.timereportClientUrl}/sick-pay-form/${bookingId}`}
      />
    );
  }

  toURI() {
    const { bookingId } = this.params;
    return `/bookings/${bookingId}/sick-form`;
  }
}
